import React, { useCallback, useContext, useEffect, useState } from 'react';
import { formatDate, formatDateTime, formatTime } from '../helpers/dateTime';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { DeleteQuizAPI } from '../redux/actions/teams/members/DeleteQuizAction';
import { DeleteSupportAPI } from '../redux/actions/teams/members/DeleteSupportAction';
import { DeleteUserAPI } from '../redux/actions/teams/members/DeleteUserAction';
import { showErrorToast, showSuccessToast } from '../helpers/toast';
import { deleteQuizStateReset } from '../redux/slices/teams/members/DeleteQuizSlice';
import { deleteSupportStateReset } from '../redux/slices/teams/members/DeleteSupportSlice';
import { deleteUserStateReset } from '../redux/slices/teams/members/DeleteUserSlice';
import { getImageUrl } from '../helpers/utils';

const Table = ({ tableData, columns, title, setDataList, setIsToggled,onEditCategory, ...props }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { parentTeamId } = useContext(AuthContext);
    const { response: deleteQuizResponse, error: deleteQuizError } = useSelector((state) => state.deleteQuiz);
    const { response: deleteSupportResponse, error: deleteSupportError } = useSelector((state) => state.deleteSupport);
    const { response: deleteUserResponse, error: deleteUserError } = useSelector((state) => state.deleteUser);

    const statusClassMap = {
        0: 'td-status st-draft',
        1: 'td-status st-pending',
        2: 'td-status st-approved',
        3: 'td-status st-rejected',
    };

    const statusClass = (status) => {
        return typeof status === 'number' ? statusClassMap[status] || '' : '';
    };

    const handleDelete = useCallback(async (data) => {
       
        Swal.fire({
            title: 'Are you sure?',
            text: title === "users"
                ? `Do you want to delete user ${data?.firstName || data?.first_name || 'N/A'} ${data?.lastName || data?.last_name || 'N/A'}?`
                : title === "quiz"
                    ? `Do you want to delete quiz ${data?.quiz_name || 'N/A'}?`
                    : title === "support"
                        ? `Do you want to delete user ${data?.name || 'N/A'}?`
                        : title === "Plans"
                            ? `Do you want to delete plan ${data?.name || 'N/A'}?`
                            : `Do you want to delete this item?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    if (title === "users") {
                        await dispatch(DeleteUserAPI(data._id));
                    } else if (title === "quiz") {
                        await dispatch(DeleteQuizAPI(data.id));
                    } else if (title === "support") {
                        await dispatch(DeleteSupportAPI(data.id));
                    } else if (title === "Api") {
                        //await dispatch(DeleteAPI(data.id));
                    }
                    // Add other conditions as needed

                    setDataList((prevList) => prevList.filter((item) => item.id !== data.id));
                    setIsToggled(true); // Trigger refetch if necessary

                    if (title === "Users") {
                        Swal.fire('Deleted!', 'User has been deleted.', 'success');
                    } else if (title === "quiz") {
                        Swal.fire('Deleted!', 'Quiz has been deleted.', 'success');
                    } else if (title === "support") {
                        Swal.fire('Deleted!', 'Support Message has been deleted.', 'success');
                    } else if (title === "Plans") {
                        Swal.fire('Deleted!', 'Plan has been deleted.', 'success');
                    } else if (title === "Api") {
                        Swal.fire('Deleted!', 'API has been deleted.', 'success');
                    }
                } catch (error) {
                    console.error('Error deleting user:', error);
                    Swal.fire('Error!', 'Failed to delete user. Please try again.', 'error');
                    setIsToggled(true);
                }
            }
        });
    }, [dispatch, setDataList, setIsToggled, title]);

    useEffect(() => {
        if (deleteQuizResponse?.status === true) {
            showSuccessToast(deleteQuizResponse?.message || 'Quiz deleted successfully');
            dispatch(deleteQuizStateReset());
        }
        if (deleteQuizError) {
            showErrorToast(deleteQuizError?.data || 'Failed to delete Quiz');
            dispatch(deleteQuizStateReset());
            setIsToggled(true); // Refetch to sync with server
        }
    }, [deleteQuizResponse, deleteQuizError, dispatch, setIsToggled]);


    useEffect(() => {
        if (deleteSupportResponse?.status === true) {
            showSuccessToast(deleteSupportResponse?.message || 'Quiz deleted successfully');
            dispatch(deleteSupportStateReset());
        }
        if (deleteSupportError) {
            showErrorToast(deleteSupportError?.data || 'Failed to delete Quiz');
            dispatch(deleteSupportStateReset());
            setIsToggled(true); // Refetch to sync with server
        }
    }, [deleteSupportResponse, deleteSupportError, dispatch, setIsToggled]);

    useEffect(() => {
        if (deleteUserResponse?.status === true) {
            showSuccessToast(deleteUserResponse?.message || 'Quiz deleted successfully');
            dispatch(deleteUserStateReset());
        }
        if (deleteUserError) {
            showErrorToast(deleteUserError?.data || 'Failed to delete Quiz');
            dispatch(deleteUserStateReset());
            setIsToggled(true); // Refetch to sync with server
        }
    }, [deleteUserResponse, deleteUserError, dispatch, setIsToggled]);



    // Function to render table row based on column data
    const renderRow = (row, index) => {
      
        return columns?.map((col, colIndex) => {
            switch (col) {
                case 'Number of Subscription Plan':
                    return <td key={colIndex}>{index + 1}</td>;
                case 'Quiz Name':
                    return <td key={colIndex}>{row?.quiz_name || '-'}</td>;
                case 'Category Name':
                    return <td key={colIndex}>{row?.name || '-'}</td>;
                case 'Icon':
                    return <td key={colIndex}>
                        <span className='td-user-img'>
                            <img src={getImageUrl(row?.category_image)} alt="" />
                        </span>
                    </td>;
                case 'Plan Name':
                    return <td key={colIndex}>{row?.plan_name || '-'}</td>;
                case 'Created On':
                    return <td key={colIndex}>{row?.createdAt ? formatDate(row?.createdAt) : 'N/A'}</td>;
                case 'Amount(£)':
                    return <td key={colIndex}>{row?.amount || '-'}</td>;
                case 'Quiz Category':
                    return <td key={colIndex}>{row?.categoryname || '-'}</td>;
                case 'Full Name':
                    return (
                        <td key={colIndex}>
                            {(row?.first_name || row?.last_name)
                                ? `${row.first_name} ${row.last_name}`
                                : row?.name || ''}
                        </td>
                    );
                case 'Email Address':
                    return <td key={colIndex}>{row?.email || '-'}</td>;
                case 'Quizzes Completed':
                    return <td key={colIndex}>{row?.quizzes_completed || '-'}</td>;
                case 'Due Date':
                    return <td key={colIndex}>{row?.due_date ? formatDate(row?.due_date) : '-'}</td>;
                case 'User Name':
                    return <td key={colIndex}>{row?.user_name || '-'}</td>;
                case 'Email':
                    return <td key={colIndex}>{row?.user_email || '-'}</td>;
                case 'Score':
                    return <td key={colIndex}>{row?.score ?? 0 }%</td>;
                case 'Completed On':
                    return <td key={colIndex}>{row?.completedAt ? formatDate(row?.completedAt) : '-'}</td>;
                case 'Status':
              
                case 'Status':
                    return (
                        <td key={colIndex}>
                            {(() => {
                                let statusValue = 0;
                                let statusText = 'Inactive';

                                // Handle different status fields
                                if (row?.statuss !== undefined) {
                                    // Support model
                                    statusText = row.statuss === 'Resolve' ? 'Resolved' :
                                        row.statuss === 'Review' ? 'Review' : 'Not Review';
                                    statusValue = row.statuss === 'Resolve' ? 2 : row.statuss === 'Review' ? 1 : 0;
                                }
                                else if (row?.isVerified !== undefined) {
                                    // Verification status
                                    statusText = row.isVerified ? 'Verified' : 'Not Verified';
                                    statusValue = row.isVerified ? 2 : 0;
                                }
                                else if (row?.status !== undefined) {
                                    // Generic status field
                                    statusText = row.status === 1 ? 'Active' : 'Inactive';
                                    statusValue = row.status === 1 ? 2 : 0;
                                }else if (row?.statusss !== undefined) {
                                    // Generic status field
                                    statusText = row.statusss === 1 ? 'Active' : 'Inactive';
                                    statusValue = row.statusss === 1 ? 2 : 0;
                                }

                                return (
                                    <span className={statusClass(statusValue)}>
                                        {statusText}
                                    </span>
                                );
                            })()}
                        </td>
                    );
                case 'Action':
                    return (
                        <td key={colIndex}>
                            <span className="table-action">
                                {pathname === '/dashboard/user-management' && (
                                    <>
                                        <button
                                            className="table-eye"
                                            onClick={() => navigate(`/dashboard/user-details/${row._id}`, { state: row })}
                                        >
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M12.9834 9.99993C12.9834 11.6499 11.6501 12.9833 10.0001 12.9833C8.35006 12.9833 7.01672 11.6499 7.01672 9.99993C7.01672 8.34993 8.35006 7.0166 10.0001 7.0166C11.6501 7.0166 12.9834 8.34993 12.9834 9.99993Z"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M9.99999 16.8918C12.9417 16.8918 15.6833 15.1584 17.5917 12.1584C18.3417 10.9834 18.3417 9.00843 17.5917 7.83343C15.6833 4.83343 12.9417 3.1001 9.99999 3.1001C7.05832 3.1001 4.31666 4.83343 2.40833 7.83343C1.65833 9.00843 1.65833 10.9834 2.40833 12.1584C4.31666 15.1584 7.05832 16.8918 9.99999 16.8918Z"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>
                                        <button
                                            className="table-edit"
                                            onClick={() => navigate(`/dashboard/user-edit/${row._id}`, { state: row })}
                                        >
                                           <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="#292D32"
                                                        strokeWidth="1.5"
                                                    >
                                                        <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M11 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"
                                                        />
                                                        <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M18.5 2.5l3 3L12 15l-4 1 1-4 9.5-9.5z"
                                                        />
                                                    </svg>
                                        </button>
                                        <button
                                            className="table-trash"
                                            onClick={() => handleDelete(row)}
                                        >
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.33325 5.83333H16.6666"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M8.33325 9.16667V14.1667"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11.6667 9.16667V14.1667"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M4.99992 5.83333L6.66659 15.8333C6.66659 16.7533 7.41325 17.5 8.33325 17.5H11.6666C12.5866 17.5 13.3333 16.7533 13.3333 15.8333L14.9999 5.83333"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M7.5 5.83333V3.33333C7.5 2.87333 7.87333 2.5 8.33333 2.5H11.6667C12.1267 2.5 12.5 2.87333 12.5 3.33333V5.83333"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </>
                                )}

                                 {pathname === '/dashboard/categories' && (
                                    <>
                                        <button
                                            className="table-edit"
                                            // onClick={() => navigate(`/dashboard/category-edit/${row._id}`, { state: row })}
                                             onClick={() => {
                                                    // Open the edit modal instead of navigating
                                                    if (onEditCategory) { // Use the destructured prop
                                                        onEditCategory(row);
                                                        // Show the modal using Bootstrap
                                                        window.$('#editCategory').modal('show');
                                                    }
                                                }}
                                        >
                                            <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="#292D32"
                                                        strokeWidth="1.5"
                                                    >
                                                        <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M11 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"
                                                        />
                                                        <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M18.5 2.5l3 3L12 15l-4 1 1-4 9.5-9.5z"
                                                        />
                                                    </svg>
                                        </button>
                                    </>
                                )}

                                {pathname === '/dashboard/quiz-management' && (
                                    <>
                                        <button
                                            className="table-eye"
                                            onClick={() => navigate(`/dashboard/quiz-details/${row.id}`, { state: row })}
                                        >
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M12.9834 9.99993C12.9834 11.6499 11.6501 12.9833 10.0001 12.9833C8.35006 12.9833 7.01672 11.6499 7.01672 9.99993C7.01672 8.34993 8.35006 7.0166 10.0001 7.0166C11.6501 7.0166 12.9834 8.34993 12.9834 9.99993Z"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M9.99999 16.8918C12.9417 16.8918 15.6833 15.1584 17.5917 12.1584C18.3417 10.9834 18.3417 9.00843 17.5917 7.83343C15.6833 4.83343 12.9417 3.1001 9.99999 3.1001C7.05832 3.1001 4.31666 4.83343 2.40833 7.83343C1.65833 9.00843 1.65833 10.9834 2.40833 12.1584C4.31666 15.1584 7.05832 16.8918 9.99999 16.8918Z"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>
                                        <button
                                            className="table-edit"
                                            onClick={() => navigate(`/dashboard/quiz-edit/${row.id}`, { state: row })}
                                        >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="#292D32"
                                                        strokeWidth="1.5"
                                                    >
                                                        <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M11 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"
                                                        />
                                                        <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M18.5 2.5l3 3L12 15l-4 1 1-4 9.5-9.5z"
                                                        />
                                                    </svg>

                                                    {/* <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="#292D32"
                                                        strokeWidth="1.5"
                                                    >
                                                        <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M12 20h9"
                                                        />
                                                        <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19.5l-4 1 1-4L16.5 3.5z"
                                                        />
                                                    </svg> */}
                                        </button>
                                        <button
                                            className="table-trash"
                                            onClick={() => handleDelete(row)}
                                        >
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.33325 5.83333H16.6666"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M8.33325 9.16667V14.1667"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11.6667 9.16667V14.1667"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M4.99992 5.83333L6.66659 15.8333C6.66659 16.7533 7.41325 17.5 8.33325 17.5H11.6666C12.5866 17.5 13.3333 16.7533 13.3333 15.8333L14.9999 5.83333"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M7.5 5.83333V3.33333C7.5 2.87333 7.87333 2.5 8.33333 2.5H11.6667C12.1267 2.5 12.5 2.87333 12.5 3.33333V5.83333"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </>
                                )}
                                {pathname === '/dashboard/support-management' && (
                                    <>
                                        <button
                                            className="table-eye"
                                            onClick={() => navigate(`/dashboard/support-details/${row.id}`, { state: row })}
                                        >
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M12.9834 9.99993C12.9834 11.6499 11.6501 12.9833 10.0001 12.9833C8.35006 12.9833 7.01672 11.6499 7.01672 9.99993C7.01672 8.34993 8.35006 7.0166 10.0001 7.0166C11.6501 7.0166 12.9834 8.34993 12.9834 9.99993Z"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M9.99999 16.8918C12.9417 16.8918 15.6833 15.1584 17.5917 12.1584C18.3417 10.9834 18.3417 9.00843 17.5917 7.83343C15.6833 4.83343 12.9417 3.1001 9.99999 3.1001C7.05832 3.1001 4.31666 4.83343 2.40833 7.83343C1.65833 9.00843 1.65833 10.9834 2.40833 12.1584C4.31666 15.1584 7.05832 16.8918 9.99999 16.8918Z"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>
                                        <button
                                            className="table-trash"
                                            onClick={() => handleDelete(row)}
                                        >
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.33325 5.83333H16.6666"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M8.33325 9.16667V14.1667"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11.6667 9.16667V14.1667"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M4.99992 5.83333L6.66659 15.8333C6.66659 16.7533 7.41325 17.5 8.33325 17.5H11.6666C12.5866 17.5 13.3333 16.7533 13.3333 15.8333L14.9999 5.83333"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M7.5 5.83333V3.33333C7.5 2.87333 7.87333 2.5 8.33333 2.5H11.6667C12.1267 2.5 12.5 2.87333 12.5 3.33333V5.83333"
                                                    stroke="#292D32"
                                                    strokeWidth="1.25"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </>
                                )}
                                {pathname === '/dashboard/subscription-management' && (
                                    <>

                                        <button
                                            className="table-edit"
                                            onClick={() => navigate(`/dashboard/subscription-edit/${row._id}`, { state: row })}
                                        >
                                            <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="#292D32"
                                                        strokeWidth="1.5"
                                                    >
                                                        <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M11 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"
                                                        />
                                                        <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M18.5 2.5l3 3L12 15l-4 1 1-4 9.5-9.5z"
                                                        />
                                                    </svg>
                                        </button>
                                    </>
                                )}
                            </span>
                        </td>
                    );
                default:
                    return <td key={colIndex}>N/A</td>;
            }
        });
    };

    return (
        <div className="common-table-wrapper">
            <div className="table-blk table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            {columns?.map((col, index) => (
                                <th key={index}>{col}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(tableData) && tableData.length > 0 ? (
                            tableData.map((row, index) => {
                                return (
                                    <tr key={row._id || index}>
                                        {renderRow(row, index)}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="100%" style={{ textAlign: 'center' }}>
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Table;
